<template>
    <div class="layui-fluid">
        <div class="layui-row layui-col-space15">
            <div class="layui-col-md12">
                <!-- <div class="layui-card">
                    <div class="layui-card-header">session设置</div>
                    <div class="layui-card-body" >
                        <div class="layui-form">
                            <div class="layui-form-item">
                                <label class="layui-form-label">session名称</label>
                                <div class="layui-input-inline" style="width: 100px;">
                                    <input type="text" value="" class="layui-input">
                                </div>
                                <div class="layui-form-mid layui-word-aux">默认session名字是JSESSIONID,该选项可以修改该值。</div>
                            </div>
                            <div class="layui-form-item">
                                <label class="layui-form-label">session超时时间</label>
                                <div class="layui-input-inline" style="width: 100px;">
                                    <input type="text" name="cache" lay-verify="number" value="0" class="layui-input">
                                </div>
                                <div class="layui-input-inline layui-input-company">分钟</div>
                                <div class="layui-form-mid layui-word-aux">本地开发一般推荐设置为 0，线上环境建议设置为 10。</div>
                            </div>
                        </div>
                    </div>
                </div> -->
                 <div class="layui-card">
                    <div class="layui-card-header">缓存设置</div>
                    <div class="layui-card-body" >
                        <div class="layui-form">
                            <div class="layui-form-item">
                                <label class="layui-form-label">刷新角色权限缓存：</label>
                                <div class="layui-input-inline" style="width: 100px;">
                                    <button class="layui-btn" @click="refreshAuth()">apply</button>
                                </div>
                            </div>
                            <div class="layui-form-item">
                                <label class="layui-form-label" style="width:480px">刷新DB_TABLES等缓存（修改DB_TABLES或者DB_TABLEFIELDS需要）：</label>
                                <div class="layui-input-inline" style="width: 100px;">
                                    <button class="layui-btn" @click="refreshDB()">apply</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="layui-card">
                    <div class="layui-card-header">登录设置</div>
                    <div class="layui-card-body" >
                        <div class="layui-form">
                            <div class="layui-form-item">
                                <label class="layui-form-label">是否开启验证码：</label>
                                <div class="layui-input-inline" style="width:140px;">
                                    <layui-radio v-model="config.cAPTCHA_ON_OFF">
                                        <input type="radio"  value="true" title="是" />
                                        <input type="radio"  value="false" title="否"/>
                                    </layui-radio>
                                </div>
                                <div class="layui-input-inline">
                                    <button class="layui-btn" @click="turnOnCaptcha()">apply</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import request from '../../../network/networkconfig';
export default {
    name: 'Setting',
    data () {
        return {
           config: {

           }
        }
    },
    mounted() {
       this.getDBSystemConfig();
    },
    methods: {
        getDBSystemConfig(){
            var getSystemConfigRequestId = "getSystemConfig";
            let data = new FormData();
            request({
                url: '/config/getSystemConfig/' + getSystemConfigRequestId,
                method: 'post',
            }).then(response => {
                if(response.errorMsg) {
                        this.layer.openAlert(response.errorMsg, false);
                } else {
                    this.config = response.result;
                }
            });
        },
        refreshAuth() {
             var refreshAuthRequestId = "refreshAuth";
             this.layer.openConfirm('确定要刷新权限缓存吗?', ()=> {
                let data = new FormData();
                request({
                    url: '/config/refreshAuthority/' + refreshAuthRequestId,
                    method: 'post',
                }).then(response => {
                    if(response.errorMsg) {
                         this.layer.openAlert(response.errorMsg, false);
                    } else {
                        this.layer.openSuccess('已重新加载权限缓存,请重新登录!');
                    }
                });
            });
        },
        refreshDB () {
          this.layer.openConfirm('确定要刷新数据库吗?', ()=> {
                request({
                    url: 'config/refreshTableInfo/refreshTable',
                    method: 'post',
                }).then(response => {
                    if(response.errorMsg) {
                         this.layer.openAlert(response.errorMsg, false);
                    } else {
                        this.layer.openSuccess('已重新加载数据库,请重新登录!');
                    }
                });
            });
        },
        turnOnCaptcha() {
             var turnOnCaptchaRequestId = "turnOnCaptcha";
             this.layer.openConfirm('确定要开启验证码吗?', ()=> {
                let data = new FormData();
                request({
                    url: '/config/turnOnCaptcha/' + this.config.cAPTCHA_ON_OFF  + '/' + turnOnCaptchaRequestId,
                    method: 'post',
                }).then(response => {
                    if(response.errorMsg) {
                         this.layer.openAlert(response.errorMsg, false);
                    } else {
                        this.layer.openSuccess('成功应用设置!');
                    }
                });
            });
        }
    }
}
</script>
<style>
    .layui-form-label {
        width: 150px;
    }
</style>



// WEBPACK FOOTER //
// src/components/platform/setting/Setting.vue